import { render, staticRenderFns } from "./VShow.vue?vue&type=template&id=26b1dfac&scoped=true"
import script from "./VShow.vue?vue&type=script&lang=js"
export * from "./VShow.vue?vue&type=script&lang=js"
import style0 from "./VShow.vue?vue&type=style&index=0&id=26b1dfac&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b1dfac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26b1dfac')) {
      api.createRecord('26b1dfac', component.options)
    } else {
      api.reload('26b1dfac', component.options)
    }
    module.hot.accept("./VShow.vue?vue&type=template&id=26b1dfac&scoped=true", function () {
      api.rerender('26b1dfac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/ComponentDetails/components/Interface/VShow.vue"
export default component.exports